class AccountApiService {
  constructor(HttpService) {
    'ngInject';

    this.HttpService = HttpService;
  }

  sendResetCode(locale, payload) {
    return this.HttpService.post('/' + locale + '/account/send/reset-code', payload);
  }

  validateResetCode(locale, payload) {
    return this.HttpService.post('/' + locale + '/account/check/reset-code', payload);
  }

  resetPassword(locale, payload) {
    return this.HttpService.post('/' + locale + '/account/reset/password', payload);
  }
}

export default AccountApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/account.api.service.js